// extracted by mini-css-extract-plugin
export default {"banner":"RestBanner_banner__QeCTp","slideDown":"RestBanner_slideDown__+Do56"};